module.exports = __webpack_public_path__ + "img/google_play-icon.207dfa11.png";